import React from "react";
import "../../App.css";
import Cards from "../Cards";

function Pesix() {
  return (
    <>
      <div className="pe06">
        <img src="images/img-19.jpg" width="100%" height="auto" alt="" />
      </div>
      <Cards />
    </>
  );
}

export default Pesix;
